import { coinABI } from '@zoralabs/protocol-deployments'
import * as semver from 'semver'

/**
 * Get the correct coin ABI based on the contract version
 */
export const getCoinABI = (version?: string) => {
  return version && semver.lt(version, '0.5.0') ? legacyCoinABI : coinABI
}

/**
 * Check if the buy result is from the legacy ABI
 */
export const isLegacyBuyResult = (result: unknown): result is bigint => {
  return typeof result === 'bigint'
}

/**
 * Check if the sell result is from the legacy ABI
 */
export const isLegacySellResult = (result: unknown): result is bigint => {
  return typeof result === 'bigint'
}

/**
 * A patched coin ABI for pre 0.5.0 versions
 */
const legacyCoinABI = coinABI.map((item) => {
  if (item.type === 'function' && (item.name === 'buy' || item.name === 'sell')) {
    return {
      ...item,
      outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    }
  }
  return item
})
